import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=61c3da32&"
import script from "./homepage.vue?vue&type=script&lang=js&"
export * from "./homepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c3da32')) {
      api.createRecord('61c3da32', component.options)
    } else {
      api.reload('61c3da32', component.options)
    }
    module.hot.accept("./homepage.vue?vue&type=template&id=61c3da32&", function () {
      api.rerender('61c3da32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sections/homepage/homepage.vue"
export default component.exports